import VElines from './src/main'

VElines.install = function(Vue) {
  Vue.component(VElines.name, VElines)
}

export default VElines
